import React from 'react';

import { ConfigurationFeatureFlag } from '@tink/config/src/tinkLinkConfig';
import { useSelectedProvider } from '../components/App/ProviderContainer/useSelectedProvider';
import {
  Configuration,
  useConfiguration,
} from '../components/ApplicationProviders/ConfigurationProvider/ConfigurationProvider';
import { applicationParameters } from '../utilities/application-parameters';
import {
  AuthorizeMachineView as AuthorizeMachineViewImport,
  AuthorizeMachineViewProps,
} from './AuthorizeMachineView';

export type AuthorizeDirectorProps = {
  AuthorizeMachineView?: React.ComponentType<AuthorizeMachineViewProps>;
};

export const AuthorizeDirector = ({
  AuthorizeMachineView = AuthorizeMachineViewImport,
}: AuthorizeDirectorProps) => {
  const { selectedProvider } = useSelectedProvider();
  const { data: configurationData } = useConfiguration();
  const shouldRedirectEarly = Configuration.hasFeatureFlag(
    configurationData,
    ConfigurationFeatureFlag.SKIP_UPDATING_CREDENTIALS
  );

  return (
    <AuthorizeMachineView
      provider={selectedProvider}
      refreshableItems={applicationParameters.get('refreshableItems')}
      shouldRedirectEarly={shouldRedirectEarly}
    />
  );
};
